/**
 * Type to describe the available item types for DAB info
 */
export enum IDabType {
  INBOUND = 'inbound',
  INBASKET = 'inBasket',
  DELIVERED = 'delivered',
}
